var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.MatchBox = function(type, number, onClickFunction) {
    var _selected = false;
    var _this = this;
    var _timeline = new TimelineMax();
    
    EHDI.GAME.pauseButton.timelineArray.push(_timeline); 
    
    var assetNum = "_0" + number;
    if(number >= 10)
        assetNum = "_" + number;
    
    this.artifactType = type + assetNum;

    EHDI.aka.Sprite.call(this, EHDI.Assets.images[this.artifactType]);
    this.anchor.set(0.5, 1);
    
    var effects = new EHDI.aka.Sprite(EHDI.Assets.images["fx_glow_green"]);
    effects.anchor.set(0.5, 0.868)
    effects.visible = false;
    this.addChild(effects);
    
    this.interactive = true;
    this.interactiveChildren = false;
    
    this.select = function() {
        effects.texture = EHDI.Assets.images["fx_glow_yellow"];
        effects.visible = true;
        effects.alpha = 1;
    }
    
    this.deselect = function() {
        effects.visible = false;
        effects.alpha = 0;
    }
    
    this.shake = function(callback) {
        _timeline.clear();
        effects.texture= EHDI.Assets.images["fx_glow_yellow"];
        effects.visible = true;
        effects.alpha = 0;
        _timeline.to(effects, 0.1, {alpha : 1, ease : Power0.easeNone});
        _timeline.to(effects, 0.1, {alpha : 0, ease : Power0.easeNone});
        _timeline.to(effects, 0.1, {alpha : 1, ease : Power0.easeNone});
        _timeline.to(effects, 0.1, {alpha : 0, ease : Power0.easeNone});
        _timeline.addCallback(function() {
//            _selected = false;
            if(callback)
                callback();
            effects.visible = false;
        });
        
    }
    
    this.correct = function(callback) {
        effects.texture = EHDI.Assets.images["fx_glow_green"];
        effects.visible = true;
        effects.alpha = 0;
        _timeline.clear();
        _timeline.to(effects, 0.1, {alpha : 1, ease : Power0.easeNone});
        _timeline.to(_this, 0.25, {alpha : 0, ease : Power0.easeNone});
        _timeline.addCallback(function() {
            if(callback)
                callback();
            _this.destroy({children : true});
        });
        
        //scale up
        //remove
    }
    
    this.incorrect = function(functionToCallAfter) {
        _timeline.clear();
        effects.texture= EHDI.Assets.images["fx_glow_red"];
        effects.visible = true;
        effects.alpha = 0;
        _timeline.to(effects, 0.1, {alpha : 1, ease : Power0.easeNone});
        _timeline.to(effects, 0.1, {alpha : 0, ease : Power0.easeNone});
        _timeline.to(effects, 0.1, {alpha : 1, ease : Power0.easeNone});
        _timeline.to(effects, 0.1, {alpha : 0, ease : Power0.easeNone});
        _timeline.addCallback(function() {
//            _selected = false;
//            _selected = false;
            effects.visible = false;
            if(functionToCallAfter) {
                functionToCallAfter();
                EHDI.GAME.soundManager.playSFX("select");
            }
        });
        
        //scale up;
        //fade out;
        //deselect;
    }
    
    this.click = function(event) {
        onClickFunction(this);
    }
    
    this.tap = function(event) {
        onClickFunction(this);
    }
}

EHDI.components.MatchBox.prototype = Object.create(EHDI.aka.Sprite.prototype);